export default __webpack_public_path__ + "static/media/CFN-CIRCLE.31dfe2f6.png";